import { useIsJobTimedOut } from '@hooks/useIsJobTimedOut';
import { useUpdateCadRunInfo } from '@hooks/useUpdateCADJob';
import type { GETCADJobResponse } from '@services/productInventory';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useProcessingFileTimeoutHandler = (cadJobResponse: GETCADJobResponse | undefined, accountId: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('createProduct');
  const { mutate: updateCadRunInfo } = useUpdateCadRunInfo();

  const hasJobTimedOut = useIsJobTimedOut(cadJobResponse);
  const isInProgress = cadJobResponse?.status === 'IN_PROGRESS_PROCESSING_CAD';

  useEffect(() => {
    if (hasJobTimedOut && isInProgress) {
      updateCadRunInfo(
        {
          runID: cadJobResponse?.runID!,
          accountId,
          status: 'IN_PROGRESS_CAD_PROCESSING_FAILED',
          errors: [{ source: 'vtaas-ui', message: `${t('timeoutError')}` }],
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(['getCadRunInfo', cadJobResponse?.runID!]);
          },
        }
      );
    }
  }, [accountId, cadJobResponse?.runID, hasJobTimedOut, isInProgress, queryClient, t, updateCadRunInfo]);
};
